(function () {
  var KEY = 'a2-signup-v1';
  var SENT = 'a2-signup-sent';
  var root = document.querySelector('[data-a2-signup]');
  if (!root) return;
  var card = root.querySelector('.a2pop-card');
  var form = root.querySelector('[data-a2pop-form]');
  var lastFocus = null;
  var openNow = false;

  function store(get, k, v) {
    try {
      if (get) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function session(get, k, v) {
    try {
      if (get) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k);
      else window.sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function focusables() {
    return Array.prototype.slice.call(
      card.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')
    );
  }

  function open() {
    if (openNow) return;
    // never on top of another open dialog (guide, cart drawer, search)
    if (document.querySelector('dialog[open]') || document.querySelector('.a2-guide.is-open')) return;
    openNow = true;
    store(false, KEY, 'seen');
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('a2pop-lock');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      var first = card.querySelector('input[type="email"]') || card.querySelector('.a2pop-x');
      if (first) first.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (!openNow) return;
    openNow = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('a2pop-lock');
    document.removeEventListener('keydown', onKey);
    window.setTimeout(function () {
      if (!openNow) root.hidden = true;
    }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    // move focus ourselves: Safari's Tab skips buttons and links and would leave the dialog
    var f = focusables().filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!f.length) return;
    e.preventDefault();
    var i = f.indexOf(document.activeElement);
    var next = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i === -1 || i === f.length - 1 ? 0 : i + 1);
    f[next].focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-a2pop-close]')) close();
  });
  if (form) {
    form.addEventListener('submit', function () {
      session(false, SENT, '1');
      store(false, KEY, 'seen');
    });
  }

  // back from sending the form: show the result (thank you or the error) right away
  if (session(true, SENT) === '1') {
    session(false, SENT, null);
    if (root.querySelector('.a2pop-ok, .a2pop-err')) {
      open();
      return;
    }
  }
  if (store(true, KEY)) return;

  var delay = (parseInt(root.getAttribute('data-delay'), 10) || 20) * 1000;
  var share = (parseInt(root.getAttribute('data-scroll'), 10) || 50) / 100;
  var timer = window.setTimeout(trigger, delay);
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= share) trigger();
  }
  function trigger() {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    if (store(true, KEY)) return;
    open();
    if (!openNow) {
      // something else was open: try once more a little later
      window.setTimeout(function () {
        if (!store(true, KEY)) open();
      }, 8000);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
